import { useState, useCallback } from "react";

const ImageFileUpload = () => {
  const [fileInfo, setFileInfo] = useState({
    size: 0,
    mime_type: "",
    width: 0,
    height: 0,
  });
  const [additionalInfo, setAdditionalInfo] = useState({
    size: 0,
    mime_type: "",
    width: 0,
    height: 0,
  });

  const extractFileMetadata = useCallback((file) => {
    if (file) {
      const img = new Image();
      img.onload = () => {
        setFileInfo({
          size: file.size / 1024,
          mime_type: file.type,
          width: img.width,
          height: img.height,
        });
      };
      img.src = URL.createObjectURL(file);
    }
  }, []);

  const extractAdditionalData = useCallback((file) => {
    if (file) {
      const img = new Image();
      img.onload = () => {
        setAdditionalInfo({
          size: file.size / 1024,
          mime_type: file.type,
          width: img.width,
          height: img.height,
        });
      };
      img.src = URL.createObjectURL(file);
    }
  }, []);

  return [fileInfo,extractFileMetadata, additionalInfo, extractAdditionalData];
};

export default ImageFileUpload;
